import { FunctionComponent, useMemo } from 'react'
import { FaTrashAlt, FaInfoCircle } from 'react-icons/fa'

import { MdRemoveRedEye, MdEdit, MdSearch } from 'react-icons/md'

import { Grid, Tooltip } from '@material-ui/core'
import Text from 'shared/components/Text'
import { colors } from 'shared/styles/colors'
import userProfile from 'shared/config/userProfile'

import {
  Container,
  TableRow,
  THead,
  TBody,
  TableHead,
  TableItem,
  IconButtonStyle,
} from './styles'
import { ITableProps } from './TableComponent.types'
import { useAuth } from 'modules/auth/hooks/auth'
import { isUserEditable } from 'shared/utils/isUserEditable'

const tableHeadCaminhoesItems = [
  {
    title: 'Nome do caminhão',
  },
  {
    title: 'Placa cavalo',
  },
  {
    title: 'Placa carreta',
  },
  {
    title: 'Placa carreta',
  },
  {
    title: 'Placa carreta',
  },
  {
    title: 'Ações',
  },
  {
    title: 'Status',
  },
]

const tableHeadMotoristasItems = [
  {
    title: 'Nome do motorista',
  },
  {
    title: 'N° CNH',
  },
  {
    title: 'Vencimento da CNH',
  },
  {
    title: 'Cnpj vinculado',
  },
  {
    title: 'Status',
  },
  {
    title: 'Observações',
  },
  {
    title: 'Ações',
  },
]

const tableHeadValePedagioMotoristasItems = [
  {
    title: 'Nome do motorista',
  },
  {
    title: 'CPF',
  },
  {
    title: 'Status',
  },
  {
    title: 'Viagens',
  },
]

const tableHeadFrotistaItems = [
  {
    title: 'Nome',
  },
  {
    title: 'CNPJ',
  },
  {
    title: 'E-mail',
  },
  {
    title: 'Status',
  },
  {
    title: 'Observação',
  },
]

const tableHeadUsuarios = [
  {
    title: 'Nome do usuário',
    minWidth: 230,
  },
  {
    title: 'Email',
    minWidth: 230,
  },
  {
    title: 'Perfil de acesso',
  },
  {
    title: 'Status',
  },
  {
    title: 'Usuário alteração',
  },
  {
    title: 'Hora alteração',
  },
  {
    title: 'Ações',
  },
]

const Table: FunctionComponent<ITableProps> = ({
  data,
  type,
  children,
  className,
}) => {
  const { perfil } = useAuth()

  const renderCaminhaoList = useMemo(
    () => (
      <>
        <THead>
          {!!tableHeadCaminhoesItems.length &&
            tableHeadCaminhoesItems?.map((item, index) => (
              <TableHead key={index}>{item?.title}</TableHead>
            ))}
        </THead>
        <TBody>
          {data &&
            !!data.length &&
            data.map(item => (
              <TableRow key={item?.id}>
                <TableItem>
                  <Grid container>
                    <Grid item md={6}>
                      {item?.descricao}
                    </Grid>

                    <Grid item md={6}>
                      <Tooltip title={item?.frotista?.cnpj} arrow>
                        <Container>
                          {item?.id ? (
                            <FaInfoCircle color={colors.blueLight} />
                          ) : (
                            <></>
                          )}
                        </Container>
                      </Tooltip>
                    </Grid>
                  </Grid>
                </TableItem>
                <TableItem>
                  <Grid container>
                    <Grid item md={6}>
                      {item?.veiculoCavalo?.placa}
                    </Grid>
                    <Grid item md={6}>
                      <Tooltip
                        title={item?.veiculoCavalo?.frotista?.cnpj}
                        arrow
                      >
                        <Container>
                          {item?.veiculoCavalo?.placa ? (
                            <FaInfoCircle color={colors.blueLight} />
                          ) : (
                            <></>
                          )}
                        </Container>
                      </Tooltip>
                    </Grid>
                  </Grid>
                </TableItem>
                <TableItem>
                  <Grid container>
                    <Grid item md={6}>
                      {item?.veiculoCarreta1?.placa}
                    </Grid>
                    <Grid item md={6}>
                      <Tooltip
                        title={item?.veiculoCarreta1?.frotista?.cnpj}
                        arrow
                      >
                        <Container>
                          {item?.veiculoCarreta1?.placa ? (
                            <FaInfoCircle color={colors.blueLight} />
                          ) : (
                            <></>
                          )}
                        </Container>
                      </Tooltip>
                    </Grid>
                  </Grid>
                </TableItem>
                <TableItem>
                  <Grid container>
                    <Grid item md={6}>
                      {item?.veiculoCarreta2?.placa}
                    </Grid>
                    <Grid item md={6}>
                      <Tooltip
                        title={item?.veiculoCarreta2?.frotista?.cnpj}
                        arrow
                      >
                        <Container>
                          {item?.veiculoCarreta2?.placa ? (
                            <FaInfoCircle color={colors.blueLight} />
                          ) : (
                            <></>
                          )}
                        </Container>
                      </Tooltip>
                    </Grid>
                  </Grid>
                </TableItem>
                <TableItem>
                  <Grid container>
                    <Grid item md={6}>
                      {item?.veiculoCarreta3?.placa}
                    </Grid>
                    <Grid item md={6}>
                      <Tooltip
                        title={item?.veiculoCarreta3?.frotista?.cnpj}
                        arrow
                      >
                        <Container>
                          {item?.veiculoCarreta3?.placa ? (
                            <FaInfoCircle color={colors.blueLight} />
                          ) : (
                            <></>
                          )}
                        </Container>
                      </Tooltip>
                    </Grid>
                  </Grid>
                </TableItem>
                <TableItem>
                  {item?.handleView && (
                    <IconButtonStyle onClick={item.handleView} transparent>
                      <MdRemoveRedEye />
                    </IconButtonStyle>
                  )}{' '}
                  {item?.handleEdit && (
                    <IconButtonStyle onClick={item.handleEdit} transparent>
                      <MdEdit />
                    </IconButtonStyle>
                  )}{' '}
                  {item?.handleDelete && (
                    <IconButtonStyle
                      onClick={item.handleDelete}
                      transparent
                      color={colors.blue}
                    >
                      <FaTrashAlt />
                    </IconButtonStyle>
                  )}
                </TableItem>
                <TableItem active={item?.ativo}>
                  {item?.ativo ? '• Ativo' : '• Inativo'}
                </TableItem>
              </TableRow>
            ))}
        </TBody>
      </>
    ),
    [data],
  )

  const renderMotoristaList = useMemo(
    () => (
      <>
        <THead>
          {!!tableHeadMotoristasItems.length &&
            tableHeadMotoristasItems?.map((item, index) => (
              <TableHead key={index}>{item?.title}</TableHead>
            ))}
        </THead>
        <TBody>
          {data &&
            !!data.length &&
            data.map(item => (
              <TableRow key={item?.id}>
                <TableItem>{item?.nome}</TableItem>
                <TableItem>{item?.cnh}</TableItem>
                <TableItem>{item?.vencimento_cnh}</TableItem>
                <TableItem>{item?.frotista?.cnpj}</TableItem>
                <TableItem active={item?.ativo}>
                  {item?.ativo ? (
                    <span style={{ color: colors.green }}>• Ativo</span>
                  ) : item.status === 'PENDENTE' ? (
                    <span style={{ color: colors.orange }}>• Pendente</span>
                  ) : (
                    <span style={{ color: colors.grayLight }}>• Inativo</span>
                  )}
                </TableItem>
                <TableItem scroll={true}>
                  {item.status === 'INVALID' ||
                  item.status === 'MANUAL_REPROVAL' ? (
                    <Grid container style={{ maxHeight: '100%' }}>
                      <Grid item xs={12}>
                        <Text size={12}>
                          {item.protocolo_ocr && (
                            <Text size={12} weight={'bold'}>
                              ({item.protocolo_ocr})
                            </Text>
                          )}
                          {item.mensagem_ocr}
                        </Text>
                        {item?.handleImageModal && (
                          <FaInfoCircle
                            style={{ marginLeft: 5 }}
                            color={colors.blueLight}
                            onClick={() =>
                              item?.handleImageModal(
                                item.id,
                                item.protocolo_ocr,
                              )
                            }
                          />
                        )}
                      </Grid>
                    </Grid>
                  ) : (
                    '-'
                  )}
                </TableItem>
                <TableItem>
                  {item?.handleView && (
                    <IconButtonStyle
                      onClick={() => {
                        if (
                          item.status !== 'INVALID' &&
                          item.status !== 'MANUAL_REPROVAL'
                        ) {
                          item.handleView(item)
                        }
                      }}
                      transparent
                    >
                      <MdRemoveRedEye
                        color={
                          (item.status === 'INVALID' ||
                            item.status === 'MANUAL_REPROVAL') &&
                          colors.grayLight
                        }
                      />
                    </IconButtonStyle>
                  )}{' '}
                  {item?.handleEdit && (
                    <IconButtonStyle
                      onClick={() => {
                        if (
                          item.status !== 'INVALID' &&
                          item.status !== 'MANUAL_REPROVAL'
                        ) {
                          item.handleEdit(item)
                        }
                      }}
                      transparent
                    >
                      <MdEdit
                        color={
                          (item.status === 'INVALID' ||
                            item.status === 'MANUAL_REPROVAL') &&
                          colors.grayLight
                        }
                      />
                    </IconButtonStyle>
                  )}{' '}
                  {item?.handleDelete && (
                    <IconButtonStyle onClick={item.handleDelete} transparent>
                      <FaTrashAlt />
                    </IconButtonStyle>
                  )}
                </TableItem>
              </TableRow>
            ))}
        </TBody>
      </>
    ),
    [data],
  )

  const renderValePedagioMotoristaList = useMemo(
    () => (
      <>
        <THead>
          {!!tableHeadValePedagioMotoristasItems.length &&
            tableHeadValePedagioMotoristasItems?.map((item, index) => (
              <TableHead key={index}>{item?.title}</TableHead>
            ))}
        </THead>
        <TBody>
          {data &&
            !!data.length &&
            data.map(item => (
              <TableRow key={item?.id}>
                <TableItem>{item?.nome}</TableItem>
                <TableItem>{item?.cpf}</TableItem>
                <TableItem active={item?.ativo}>
                  {item?.ativo ? (
                    <span style={{ color: colors.green }}>• Ativo</span>
                  ) : item.status === 'PENDENTE' ? (
                    <span style={{ color: colors.orange }}>• Pendente</span>
                  ) : (
                    <span style={{ color: colors.grayLight }}>• Inativo</span>
                  )}
                </TableItem>
                <TableItem>
                  <IconButtonStyle
                    onClick={() => {
                      if (
                        item.status !== 'INVALID' &&
                        item.status !== 'MANUAL_REPROVAL'
                      ) {
                        item.handleView(item)
                      }
                    }}
                    transparent
                  >
                    <MdRemoveRedEye
                      color={
                        (item.status === 'INVALID' ||
                          item.status === 'MANUAL_REPROVAL') &&
                        colors.grayLight
                      }
                    />
                  </IconButtonStyle>
                </TableItem>
              </TableRow>
            ))}
        </TBody>
      </>
    ),
    [data],
  )

  const renderFrotistaList = useMemo(
    () => (
      <>
        <THead>
          {!!tableHeadFrotistaItems.length &&
            tableHeadFrotistaItems?.map((item, index) => (
              <TableHead key={index}>{item?.title}</TableHead>
            ))}
        </THead>
        <TBody>
          {data &&
            !!data.length &&
            data.map(item => (
              <TableRow key={item?.id}>
                <TableItem>
                  {item.is_matriz ? (
                    <strong>{item?.razao_social}</strong>
                  ) : (
                    item?.razao_social
                  )}
                </TableItem>
                <TableItem>
                  {item.is_matriz ? <strong>{item?.cnpj}</strong> : item?.cnpj}
                </TableItem>
                <TableItem>
                  {item.is_matriz ? (
                    <strong>{item?.email}</strong>
                  ) : (
                    item?.email
                  )}
                </TableItem>
                <TableItem>
                  {item?.status === 'VALID' ||
                  item.status === 'MANUAL_APPROVAL' ? (
                    <span style={{ color: colors.green }}>• Ativo</span>
                  ) : item.status === 'INVALID' ||
                    item.status === 'MANUAL_REPROVAL' ? (
                    <span style={{ color: colors.grayLight }}>• Inativo</span>
                  ) : (
                    <span style={{ color: colors.orange }}>• Pendente</span>
                  )}
                </TableItem>
                <TableItem>
                  {item.is_matriz ? (
                    <strong>{item?.mensagem_ocr}</strong>
                  ) : (
                    item?.mensagem_ocr
                  )}
                </TableItem>
              </TableRow>
            ))}
        </TBody>
      </>
    ),
    [data],
  )

  const renderUsuarioVincList = useMemo(() => {
    return (
      <>
        <THead>
          {!!tableHeadUsuarios.length &&
            tableHeadUsuarios?.map((item, index) => (
              <TableHead key={index} style={{ minWidth: item.minWidth || 100 }}>
                {item?.title}
              </TableHead>
            ))}
        </THead>
        <TBody>
          {data &&
            !!data.length &&
            data.map(item => (
              <TableRow key={item?.id}>
                <TableItem style={{ minWidth: 230 }}>{item?.nome}</TableItem>
                <TableItem style={{ minWidth: 230 }}>{item?.login}</TableItem>
                <TableItem>
                  {item?.perfil === userProfile.status.operacional
                    ? 'Operacional'
                    : 'Administrador'}
                </TableItem>
                <TableItem>
                  {item?.ativo ? (
                    <span style={{ color: colors.green }}>• Ativo</span>
                  ) : (
                    <span style={{ color: colors.grayLight }}>• Inativo</span>
                  )}
                </TableItem>
                <TableItem>
                  {item?.usuario_log_id ? item?.usuario_alteracao.nome : ''}
                </TableItem>
                <TableItem>
                  {item?.usuario_log_id
                    ? `${new Date(item?.updated_at).toLocaleDateString(
                        'pt-BR',
                      )} ${new Date(item?.updated_at).toLocaleTimeString(
                        'pt-BR',
                      )} `
                    : ''}
                </TableItem>
                {item?.handleEdit && (
                  <TableItem>
                    <IconButtonStyle onClick={item.handleEdit} transparent>
                      {isUserEditable(perfil, item.perfil) ? (
                        <MdEdit />
                      ) : (
                        <MdSearch />
                      )}
                    </IconButtonStyle>
                  </TableItem>
                )}{' '}
              </TableRow>
            ))}
        </TBody>
      </>
    )
  }, [data, perfil])

  return (
    <Container className={className}>
      {type === 'caminhão' && renderCaminhaoList}
      {type === 'motorista' && renderMotoristaList}
      {type === 'vale_pedagio_motorista' && renderValePedagioMotoristaList}
      {type === 'frotista' && renderFrotistaList}
      {type === 'usuario_vinc' && renderUsuarioVincList}
      {children}
    </Container>
  )
}
export default Table
